import React from 'react';
import KoobTooltip from '@koob/ui/src/components/KoobTooltip';
import TripDayItem from '../TripDayItem';
import TripDayItemRemoveButton from '../TripDayItemRemoveButton';

// Not distributed to us: the day keeps its hotel, shown by name and address
// only, with no link to a factsheet we would not be allowed to open. The
// remove button stays so the product can still be replaced.
export default function TripDayHotelUnavailable({
  hotel,
  isIncludedHotel,
  onRemove,
  t,
}: {
  hotel: any;
  isIncludedHotel: any;
  onRemove: () => void;
  t: (key: string, options?: Record<string, any>) => string;
}) {
  return (
    <TripDayItem>
      <div className="relative p-3">
        {!isIncludedHotel && <TripDayItemRemoveButton onClick={onRemove} />}

        <div className="font-semibold text-gray-900">
          {hotel?.name ?? hotel?.displayName}
        </div>
        <KoobTooltip
          tip={t('productAccess.productDescription')}
          color="red"
          hasArrow={false}
          position="left"
        >
          <i
            className="fa-light fa-triangle-exclamation"
            style={{ fontSize: 20, color: 'red' }}
          />
        </KoobTooltip>
        {hotel?.address && (
          <div className="text-sm text-gray-500">{hotel.address}</div>
        )}
      </div>
    </TripDayItem>
  );
}
